/*
 * Copyright 2025 Intuition Robotics ltd
 */
export const config = {
    "ThunderstormModule": {
        "appName": "Care Center"
    },
    "XhrHttpModule": {
        "origin": "/api",
        "timeout": 30000
    },
    "ServiceWorker": {
        "firebaseVersion": "8.2.6"
    },
    "ForceUpgrade": {
        "assertVersionUrl": "/v1/version/assert"
    },
    "EnvironmentModule": {
        "envName": "prod",
        "kasperoUrl": "https://login.intuitionrobotics.com"
    },
    "FirebaseModule": {
        "local": {
            "apiKey": "AIzaSyAt9oLmO3IUXY3ZxTaW1oRGBnRtBeauBNY",
            "authDomain": "ir-q-care-center.firebaseapp.com",
            "databaseURL": "https://ir-q-care-center.firebaseio.com",
            "projectId": "ir-q-care-center",
            "storageBucket": "ir-q-care-center.appspot.com",
            "messagingSenderId": "826628488004",
            "appId": "1:826628488004:web:4aeeec8a507c0e2cf77511",
            "measurementId": "G-NXWCKY7JDV"
        }
    },
    "PushPubSubModule": {
        "publicKeyBase64": "BGbnhYJGoXYany6swSDwukO4lIWCLG2zUtUb7X8f6ah0mXanS7fTH9yvF0arz_PcUorsoJRzLKa624D-LOVw7WI",
        "registerOnInit": false,
        "swFileName": "sw.js"
    },
    "commandsUrl": "https://ir-commands.web.app"
}
